// eslint-disable-next-line no-unused-vars
import React, { useEffect, useState } from "react";
import getComponent from "../../_Case/ComponentsList";
import { removeRequiredListKeys } from "redux/actions/requiredListActions";
import { useDispatch } from "react-redux";
import { useIntl } from "react-intl";

const InspectionApprovedByComponent = ({ myName, getValue, getSavedValue, setValue, formComponentData }) => {
  const intl = useIntl();

  const [diameterOverTwoHundred, setDiameterOverTwoHundred] = useState("");
  const [isRecommendationPotentionalForRemanufacturing, setIsRecommendationPotentionalForRemanufacturing] = useState(false);
  const [isFirstPotentialForRemanufacturing, setIsFirstPotentialForRemanufacturing] = useState(true);
  const [approversName, setApproversName] = useState("");
  const [managerApprover, setManagerApprover] = useState("");
  const [solutionFactoryName, setSolutionFactoryName] = useState("");
  const [solutionFactoryCoordinator, setSolutionFactoryCoordinator] = useState("");
  const solutionFactory = formComponentData.args.find(a => a.key === 'solutionFactory')

  const dispatch = useDispatch();

  useEffect(() => {
    const index = getIndexValue(myName);
    const recommendationValue = getSavedValue(`bearingInvestigations.bearingInvestigation[${index}].recommendations.recommendations`)?.value
    if (!recommendationValue) {
      setIsRecommendationPotentionalForRemanufacturing(false);
      return;
    };

    const bearingInvestigationsCount = +getSavedValue('bearingInvestigations.count');

    if (bearingInvestigationsCount > 1) {
      const otherPtentialForRemanufacturing = Array.from({ length: bearingInvestigationsCount }).some((_, i) => {
        // i is number while index is string
        if (i == index) return false;
        const solutionFactoryName = getSavedValue(`bearingInvestigations.bearingInvestigation[${i}].recommendations.reportNeedsApproval`)?.solutionFactoryName;
        return !!solutionFactoryName;
      });
      setIsFirstPotentialForRemanufacturing(
        !otherPtentialForRemanufacturing
      );
    }

    setIsRecommendationPotentionalForRemanufacturing(
      recommendationValue === 'potentialForReconditioning' || recommendationValue === 'potentialForRemanucaturing'
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getSavedValue, myName, getValue]);

  useEffect(() => {
    const values = getValue(myName) ?? {};
      setDiameterOverTwoHundred(values.diameterOverTwoHundred ?? "");
      setApproversName(values.approversName ?? "");
      setManagerApprover(values.managerApprover ?? "");
      setSolutionFactoryName(values.solutionFactoryName ?? "");
      setSolutionFactoryCoordinator(values.solutionFactoryCoordinator ?? "");
  }, [getValue, myName]);

  const handleChange = (value, name) => {
    var resultName = name.split(".").pop();
    let objectToSave = { diameterOverTwoHundred, managerApprover, solutionFactoryName, approversName, solutionFactoryCoordinator };

    if (resultName === "diameterOverTwoHundred") {
      if (value === "true") {
        setManagerApprover("");
        setApproversName("");
        objectToSave = { ...objectToSave, managerApprover: "", approversName: "" };
      } else {
        setSolutionFactoryName("");
        setSolutionFactoryCoordinator("");
        setApproversName("");
        objectToSave = { ...objectToSave, solutionFactoryName: "", solutionFactoryCoordinator: "", approversName: "" };
        objectToSave.solutionFactoryName = "";
        objectToSave.approversName = "";
      }
      removeFromRequiredList(value);
      setDiameterOverTwoHundred(value);
      objectToSave = { ...objectToSave, diameterOverTwoHundred: value };
      setValue(objectToSave, myName);
    } else if (resultName === "managerApprover") {
      setManagerApprover(value);
      setApproversName(value);
      objectToSave = { ...objectToSave, managerApprover: value, approversName: value };
      setValue(objectToSave, myName);
    } else if (resultName === "solutionFactoryName") {
      setSolutionFactoryName(value);
      setSolutionFactoryCoordinator(value.value ? value.value.email : "");
      setApproversName(value.value ? value.value.email : "");
      objectToSave = { ...objectToSave, solutionFactoryName: value, solutionFactoryCoordinator: value.value ? value.value.email : "", approversName: value.value ? value.value.email : "" };
      setValue(objectToSave, myName);
    }
  }

  const removeFromRequiredList = (value) => {
    if (value === "true") {
      dispatch(removeRequiredListKeys(`${myName}.managerApprover`));
    } else {
      dispatch(removeRequiredListKeys(`${myName}.solutionFactoryName`));
    }
  };

  const renderYesOrNo = () => {
    if (diameterOverTwoHundred === "true" || (isRecommendationPotentionalForRemanufacturing && isFirstPotentialForRemanufacturing)) {
      return renderYes();
    } else if (diameterOverTwoHundred === "false") {
      return renderNo();
    } else {
      removeFromRequiredList("false")
      return null;
    }
  };

  const renderYes = () => {
    const emailDisplay = solutionFactoryCoordinator
      ? solutionFactoryCoordinator
          .split(/[;,]/)
          .map(e => e.trim())
          .filter(e => e.length > 0)
          .join("; ")
      : "";

    return (
      <>
        {getComponent(
          solutionFactory,
          `${myName}.solutionFactoryName`, handleChange, solutionFactoryName
        )}
        {emailDisplay && (
          <div className="input-shell">
            <label className="input-shell__label input-shell__label--dark">
              {intl.formatMessage({ id: 'solutionFactoryCoordinator' })}
            </label>
            <div className="input-shell__container">
              <input
                type="text"
                value={emailDisplay}
                readOnly
                className="input__element"
              />
            </div>
          </div>
        )}
      </>
    );
  };

  const renderNo = () => {
    return (
      <>
        {getComponent(
          {
            type: "AutoComplete",
            key: "managerApproverExternal",
            description: "Report Approved By (Report by Manager)",
            args: [
              { apiPath: "lists/approvers" },
              {
                valueLabelParams: {
                  value: "email",
                  label: "name",
                },
              },
            ],
            required: true,
          },
          `${myName}.managerApprover`, handleChange, managerApprover
        )}
      </>
    );
  };



  const renderComponents = (formComponent, index) => {
    if (formComponent) {
      if (formComponent.key === "diameterOverTwoHundred") {
        return (
          <div key={index}>
            {getComponent(
              formComponent,
              `${myName}.${formComponent.key}`,
              handleChange,
              diameterOverTwoHundred
            )}
          </div>
        );
      }
    }
  };

  const getIndexValue = value => {
    const match = value?.match(/\[(.*?)\]/)
    return match ? match[1] : '-1'
  }

  return <>
    {formComponentData.args.map((formComponent, index) => {
      return renderComponents(formComponent, index);
    })}
    {renderYesOrNo()}
  </>;

}

export default InspectionApprovedByComponent;